import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSpotify = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 25,
	viewBox: "0 0 24 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M12 24.5C18.624 24.5 24 19.124 24 12.5C24 5.876 18.624 0.5 12 0.5C5.376 0.5 0 5.876 0 12.5C0 19.124 5.376 24.5 12 24.5ZM16.872 18.156V18.157C16.065 18.157 13.516 15.329 6.352 16.797C6.163 16.846 5.916 16.923 5.776 16.923C4.861 16.923 4.686 15.554 5.67 15.345C9.633 14.47 13.683 14.547 17.137 16.613C17.961 17.139 17.611 18.156 16.872 18.156ZM18.175 14.983C18.062 14.953 18.095 15.052 17.578 14.78C14.553 12.99 10.045 12.268 6.033 13.357C5.801 13.42 5.675 13.483 5.457 13.483C4.386 13.483 4.102 11.872 5.269 11.543C9.985 10.218 15.044 10.991 18.566 13.086C18.958 13.318 19.113 13.619 19.113 14.039C19.108 14.561 18.702 14.983 18.175 14.983ZM4.548 7.498C9.071 6.174 15.916 6.592 20.172 9.076C21.263 9.705 20.834 11.296 19.674 11.296L19.673 11.295C19.421 11.295 19.266 11.232 19.048 11.106C15.605 9.05 9.444 8.557 5.458 9.67C5.283 9.718 5.065 9.795 4.833 9.795C4.194 9.795 3.706 9.296 3.706 8.653C3.706 7.996 4.113 7.624 4.548 7.498Z",
			fill: "#1CB954"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white",
			transform: "translate(0 0.5)"
		})
	}) })]
});
export default SvgSpotify;
